import React, { useState, useMemo } from "react";
import { Flex, Typography } from "antd";
import { Country } from "country-state-city";
import { SbButton, BUTTON_TYPE, SbInput, SbRow, SbCol } from "uiCore";
import SbCard from "uiCore/SbCard/SbCard";
import { FullWidthSelectStyled } from "./LegalEntityManagement.styles";

const { Text } = Typography;

const AddEntityForm = ({ existingNames = [], onAdd, onCancel }) => {
  const [name, setName] = useState("");
  const [location, setLocation] = useState("");
  const [currency, setCurrency] = useState("USD");
  const [nameError, setNameError] = useState("");
  const [locationError, setLocationError] = useState("");

  // Country dropdown options sourced from country-state-city (ISO list).
  // Memoised so the list is built once per mount, not on every render.
  const countryOptions = useMemo(
    () =>
      Country.getAllCountries().map((c) => ({
        value: c.name,
        label: c.name,
      })),
    []
  );

  const submit = () => {
    const trimmedName = name.trim();
    const trimmedLocation = location.trim();
    let hasError = false;

    if (
      trimmedName &&
      existingNames.some(
        (n) => n?.toLowerCase() === trimmedName.toLowerCase()
      )
    ) {
      setNameError("This legal entity already exists");
      hasError = true;
    }
    if (!trimmedLocation) {
      setLocationError("Location is required");
      hasError = true;
    }
    if (hasError) return;

    onAdd({
      legal_entity: trimmedName,
      legal_entity_description: " ",
      company_structure_location: trimmedLocation,
      company_structure_override: false,
      currency_info: {
        fx_hq_to_local: null,
        fx_last_updated: null,
        fx_operational_year: null,
        fx_updated_by: null,
        local_currency: currency,
      },
      locations: [{ name: trimmedLocation, type: "" }],
      business_units: [],
    });
    setName("");
    setLocation("");
    setCurrency("USD");
    setNameError("");
    setLocationError("");
  };

  return (
    <SbCard>
      <SbRow gutter={10} align="top" wrap={false}>
        <SbCol flex="auto">
          <SbInput
            autoFocus
            status={nameError ? "error" : undefined}
            placeholder="Legal entity (e.g. US - SkillsBridge.AI USA)"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
              if (nameError) setNameError("");
            }}
            onPressEnter={submit}
          />
          {nameError && <Text type="danger">{nameError}</Text>}
        </SbCol>
        <SbCol flex="auto">
          <FullWidthSelectStyled
            showSearch
            options={countryOptions}
            status={locationError ? "error" : undefined}
            placeholder="Select country"
            value={location || undefined}
            onChange={(val) => {
              setLocation(val);
              if (locationError) setLocationError("");
            }}
          />
          {locationError && <Text type="danger">{locationError}</Text>}
        </SbCol>
        <SbCol flex="none">
          <Flex gap={8}>
            <SbButton buttonType={BUTTON_TYPE.PRIMARY} onClick={submit}>
              Add
            </SbButton>
            <SbButton buttonType={BUTTON_TYPE.SECONDARY} onClick={onCancel}>
              Cancel
            </SbButton>
          </Flex>
        </SbCol>
      </SbRow>
    </SbCard>
  );
};

export default AddEntityForm;